import React, { PureComponent } from 'react';
import { string } from 'prop-types';
import TextField from '../../SolvPatternLibrary/TextField';
import { formShape } from 'rc-form';
import { emptyFieldValidator } from '../../../core/util/rcForm/validators';
import { FIRST_NAME_ID } from './ids';

export default class NameInput extends PureComponent {
  static propTypes = {
    form: formShape.isRequired,
    className: string,
    fieldId: string,
  };

  get inputProps() {
    const { form, className, fieldId } = this.props;
    const error = form.getFieldError(fieldId);
    return {
      ...form.getFieldProps(fieldId, {
        validateTrigger: ['onBlur', 'onChange'],
        rules: [
          {
            required: true,
            validator: emptyFieldValidator,
          },
        ],
      }),
      value: undefined,
      id: fieldId,
      label: fieldId === FIRST_NAME_ID ? 'First Name' : 'Last Name',
      helperText: <span>{Array.isArray(error) && error[0]}</span>,
      error: !!error,
      className,
      type: 'text',
    };
  }

  render = () => <TextField {...this.inputProps} />;
}
